/**
 * Iron Skillet PDP — Interactive JS
 *
 * Gallery swap, size/accessory selector, savings tracker, CTA updates,
 * slots-remaining countdown, FAQ accordion, scroll animations,
 * add-to-cart via /cart/add.js, cart drawer integration, and
 * out-of-stock redirect logic.
 *
 * Image URLs are injected by Liquid via onclick attributes on gallery
 * thumbnails using Shopify's `| asset_url` filter.
 */

/* ── View item event (Google view_item / Meta ViewContent) ───────── */
// Fires once on page load via TrainingAnalytics so GTM can forward
// to Google Ads (view_item) and Meta (ViewContent).

(function () {
  var ta = window.TrainingAnalytics;
  if (!ta) return;

  var mapEl = document.getElementById('iron-skillet-variant-map');
  if (!mapEl) return;

  try {
    var data = JSON.parse(mapEl.textContent);
    if (!data.product_id || !data.variants || !data.variants.length) return;

    // Use the active (default-selected) variant, fall back to first
    var v = data.variants[0];
    var activeBtn = document.querySelector('.size-btn.active');
    if (activeBtn && activeBtn.getAttribute('data-variant-id')) {
      var activeId = parseInt(activeBtn.getAttribute('data-variant-id'), 10);
      for (var i = 0; i < data.variants.length; i++) {
        if (data.variants[i].id === activeId) { v = data.variants[i]; break; }
      }
    }

    // Build a minimal cart-shaped object that pushEvent expects
    var fakeCart = {
      total_price: v.price,
      currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : 'USD',
      item_count: 1,
      items: [{
        product_id: data.product_id,
        product_title: 'ILUME Cast Iron Skillet',
        variant_id: v.id,
        variant_title: v.title,
        product_type: 'Cookware',
        vendor: 'ILUME',
        url: window.location.pathname,
        image: null,
        sku: null,
        final_price: v.price,
        quantity: 1,
        selling_plan_allocation: null
      }]
    };

    ta.pushEventOnce('view_item_stape', fakeCart, { pageType: 'product' });
  } catch (e) {
    // Analytics failure is non-blocking
  }
})();

/* ── Gallery swap ─────────────────────────────────────────────────── */

/**
 * Swaps the main gallery image with a fade transition.
 * Called via inline onclick on .gallery-thumb elements;
 * `src` is a Shopify asset URL resolved at render-time by Liquid.
 *
 * @param {HTMLElement} thumb - The clicked thumbnail element
 * @param {string}      src   - Shopify asset URL for the full-size image
 */
var _gallerySwapTimer = null;
function swapMain(thumb, src) {
  var mainImg = document.querySelector('.gallery-main img');
  if (mainImg) {
    if (_gallerySwapTimer) clearTimeout(_gallerySwapTimer);
    mainImg.style.transition = 'opacity 0.15s ease';
    mainImg.style.opacity = '0';
    _gallerySwapTimer = setTimeout(function () {
      _gallerySwapTimer = null;
      mainImg.src = src;
      mainImg.style.opacity = '1';
    }, 150);
  }
  document.querySelectorAll('.gallery-thumb').forEach(function (t) {
    t.classList.remove('active');
  });
  thumb.classList.add('active');
}

/* ── Product data ─────────────────────────────────────────────────── */

var variantMap = null;
try {
  var mapEl = document.getElementById('iron-skillet-variant-map');
  if (mapEl) variantMap = JSON.parse(mapEl.textContent);
} catch (e) {
  console.warn('Iron Skillet: Could not parse variant map', e);
}

/* ── Pricing state ────────────────────────────────────────────────── */

var sizeDiscount = 70; // default matches the active 10" size (Save $70)
var currentSize = '10'; // tracks the selected size label (inches)
var currentPrice = '$159';
var currentWas = '$229';
var currentVariantId = null;
var giftState = { leather: false, seasoning: false, chainmail: false, recipe: false };
var giftValues = { leather: 29, seasoning: 17, chainmail: 32, recipe: 27 };

// Initialize currentVariantId from the default active size button
(function () {
  var activeBtn = document.querySelector('.size-btn.active');
  if (activeBtn && activeBtn.getAttribute('data-variant-id')) {
    currentVariantId = activeBtn.getAttribute('data-variant-id');
  }
})();

/* ── CTA button updates ──────────────────────────────────────────── */

function updateCtaButtons() {
  // Parse current numeric price
  var priceNum = parseInt(currentPrice.replace('$', ''));
  var wasNum = parseInt(currentWas.replace('$', ''));

  // Calculate total accessories value
  var accessoryVal = Object.entries(giftState)
    .filter(function (entry) { return entry[1]; })
    .reduce(function (sum, entry) { return sum + giftValues[entry[0]]; }, 0);

  var totalWas = wasNum + accessoryVal;
  var displayPrice = '$' + priceNum;
  var displayWas = '$' + totalWas;

  // Update main CTA
  var ctaBtn = document.getElementById('cta-btn');
  if (ctaBtn) {
    ctaBtn.innerHTML =
      'Add to Cart — <span id="cta-strike" style="text-decoration:line-through; opacity:0.6; font-weight:400;">' +
      displayWas +
      '</span> <span id="cta-price" style="font-weight:700;">' +
      displayPrice +
      '</span> &nbsp; <span class="arrow">→</span>';
  }

  // Update bottom CTA
  var ctaBtnBottom = document.getElementById('cta-btn-bottom');
  if (ctaBtnBottom) {
    ctaBtnBottom.innerHTML =
      'Add to Cart — <span id="cta-strike-bottom" style="text-decoration:line-through; opacity:0.6; font-weight:400;">' +
      displayWas +
      '</span> <span id="cta-price-bottom" style="font-weight:700;">' +
      displayPrice +
      '</span> &nbsp; <span class="arrow">→</span>';
  }
}

/* ── Savings bar ─────────────────────────────────────────────────── */

function updateSavingsBar() {
  var accessorySavings = Object.entries(giftState)
    .filter(function (entry) { return entry[1]; })
    .reduce(function (sum, entry) { return sum + giftValues[entry[0]]; }, 0);

  var total = sizeDiscount + accessorySavings;
  var tv = document.getElementById('gift-total-val');
  if (tv) {
    tv.textContent = '$' + total;
    tv.style.color = 'var(--green-light)';
  }
  updateCtaButtons();
}

/* ── Accessory (gift) toggling ───────────────────────────────────── */

function toggleGift(id, val) {
  giftState[id] = !giftState[id];
  var el = document.getElementById('gift-' + id);
  if (el) el.classList.toggle('gift-selected', giftState[id]);
  updateSavingsBar();
}

/* ── Size selector ───────────────────────────────────────────────── */

function selectSize(btn, price, was, save) {
  document.querySelectorAll('.size-btn').forEach(function (b) {
    b.classList.remove('active');
  });
  btn.classList.add('active');
  currentPrice = price;
  currentWas = was;

  // Read variant ID from data attribute
  if (btn.getAttribute('data-variant-id')) {
    currentVariantId = btn.getAttribute('data-variant-id');
  }

  // Extract size label from button text, e.g. "8 in." → "8"
  var sizeMatch = btn.textContent.match(/(\d+)\s*in/);
  if (sizeMatch) currentSize = sizeMatch[1];

  // Parse save amount, e.g. "Save $69" → 69
  var match = save.match(/\$(\d+)/);
  if (match) {
    sizeDiscount = parseInt(match[1]);
    updateSavingsBar();
  }
}

/* ── Add to Cart ─────────────────────────────────────────────────── */

var _addingToCart = false;

function getSelectedGiftVariantIds() {
  var ids = [];
  if (!variantMap || !variantMap.gifts) return ids;

  Object.keys(giftState).forEach(function (key) {
    if (giftState[key] && variantMap.gifts[key]) {
      ids.push(variantMap.gifts[key]);
    }
  });
  return ids;
}

function addToCart(btn) {
  if (_addingToCart) return;
  if (!currentVariantId) {
    // Scroll to size selector if no variant selected
    var sizeSection = document.getElementById('size-options');
    if (sizeSection) sizeSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return;
  }

  _addingToCart = true;
  var originalHtml = btn.innerHTML;
  btn.innerHTML = 'Adding…';
  btn.disabled = true;

  // Collect cart-items section IDs for Section Rendering API
  var cartSectionIds = [];
  document.querySelectorAll('cart-items-component').forEach(function (el) {
    if (el.dataset && el.dataset.sectionId) {
      cartSectionIds.push(el.dataset.sectionId);
    }
  });

  // Build main product form data
  var formData = new FormData();
  formData.append('id', currentVariantId);
  formData.append('quantity', '1');
  if (cartSectionIds.length > 0) {
    formData.append('sections', cartSectionIds.join(','));
  }

  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(function (r) { return r.json(); })
  .then(function (response) {
    if (response.status) {
      // Error from Shopify
      console.error('Add to cart error:', response.description || response.message);
      btn.innerHTML = response.description || 'Error';
      setTimeout(function () { btn.innerHTML = originalHtml; }, 3000);
      return;
    }

    // Now add selected free gift items
    var giftIds = getSelectedGiftVariantIds();
    var productId = variantMap ? variantMap.product_id : '';

    if (giftIds.length > 0) {
      var giftItems = giftIds.map(function (id) {
        return {
          id: id,
          quantity: 1,
          properties: { _free_gift: 'true', _gift_parent: String(productId) }
        };
      });

      var giftBody = { items: giftItems };
      if (cartSectionIds.length > 0) {
        giftBody.sections = cartSectionIds.join(',');
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(giftBody)
      })
      .then(function (r) { return r.json(); })
      .then(function (giftResponse) {
        dispatchCartUpdate(giftResponse.sections, 1 + giftIds.length);
        pushAddToCartEvent();
      })
      .catch(function (err) {
        console.warn('Free gifts ATC error:', err);
        // Still dispatch cart update for the main product
        dispatchCartUpdate(response.sections, 1);
        pushAddToCartEvent();
      });
    } else {
      dispatchCartUpdate(response.sections, 1);
      pushAddToCartEvent();
    }

    // Brief "Added!" feedback on all CTA buttons
    var allCtaBtns = document.querySelectorAll('#cta-btn, #cta-btn-bottom, .btn-nav[data-ps-atc-btn]');
    allCtaBtns.forEach(function (b) {
      var origHtml = b.innerHTML;
      b.innerHTML = '✓ Added!';
      setTimeout(function () { b.innerHTML = origHtml; updateCtaButtons(); }, 1800);
    });
  })
  .catch(function (error) {
    console.error('Iron Skillet ATC error:', error);
    btn.innerHTML = originalHtml;
  })
  .finally(function () {
    _addingToCart = false;
    btn.disabled = false;
    // Ensure button text resets if still showing "Adding…"
    setTimeout(function () {
      if (btn.innerHTML === 'Adding…') {
        btn.innerHTML = originalHtml;
      }
    }, 3000);
  });
}

function dispatchCartUpdate(sections, itemCount) {
  // Dispatch cart:update event — triggers cart drawer open via cart-drawer.js
  document.dispatchEvent(new CustomEvent('cart:update', {
    bubbles: true,
    detail: {
      resource: {},
      sourceId: 'iron-skillet',
      data: {
        source: 'iron-skillet',
        itemCount: itemCount,
        productId: variantMap ? variantMap.product_id : null,
        variantId: currentVariantId,
        sections: sections || null
      }
    }
  }));

  // Also dispatch CartAddEvent if the custom element class is defined
  // This is what cart-drawer.js listens to for auto-open
  try {
    var CartAddEvent = window.CartAddEvent;
    if (!CartAddEvent) {
      // Manually dispatch a bubbling event matching the CartAddEvent pattern
      document.dispatchEvent(new CustomEvent('cart-add', { bubbles: true }));
    }
  } catch (e) { /* ignore */ }
}

/* ── GTM / dataLayer tracking ────────────────────────────────────── */

function pushAddToCartEvent() {
  if (typeof window.TrainingAnalytics === 'undefined') return;

  // Fetch current cart state for the analytics push
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      window.TrainingAnalytics.pushEvent('add_to_cart', cart, {
        pageType: 'product'
      });
    })
    .catch(function () { /* analytics failure is non-blocking */ });
}

/* ── CTA click handler (delegated) ──────────────────────────────── */

document.addEventListener('click', function (e) {
  var atcBtn = e.target.closest('[data-ps-atc-btn]');
  if (!atcBtn) return;

  // If out-of-stock, let the redirect handler below take over
  var section = document.querySelector('.iron-skillet-section[data-product-available]');
  if (section && section.getAttribute('data-product-available') === 'false') return;

  e.preventDefault();
  addToCart(atcBtn);
});

/* ── Slots remaining ─────────────────────────────────────────────── */
// Deterministic from hour + minute so the number feels live but is
// consistent for every visitor at the same clock-minute.

(function () {
  var now = new Date();
  var minuteOfDay = now.getHours() * 60 + now.getMinutes();
  // Starts at 50, drops ~1 every 20 min across the day, floored at 4
  var slots = Math.max(4, 50 - Math.floor(minuteOfDay / 20));
  var text = slots + ' slot' + (slots === 1 ? '' : 's') + ' left today';

  var el1 = document.getElementById('slots-remaining');
  var el2 = document.getElementById('slots-remaining-2');
  if (el1) el1.textContent = text;
  if (el2) el2.textContent = text + '.';

  // Decrement by 1 after 45 s on page (simulates another order)
  setTimeout(function () {
    var updated = Math.max(3, slots - 1);
    var updatedText = updated + ' slot' + (updated === 1 ? '' : 's') + ' left today';
    if (el1) el1.textContent = updatedText;
    if (el2) el2.textContent = updatedText + '.';
  }, 45000);
})();

/* ── FAQ accordion ───────────────────────────────────────────────── */

function toggleFaq(el) {
  var item = el.parentElement;
  var isOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item').forEach(function (i) {
    i.classList.remove('open');
    var q = i.querySelector('.faq-question');
    if (q) q.setAttribute('aria-expanded', 'false');
  });
  if (!isOpen) {
    item.classList.add('open');
    el.setAttribute('aria-expanded', 'true');
  }
}

/* ── Scroll-triggered fade-in ────────────────────────────────────── */

var observer = new IntersectionObserver(
  function (entries, obs) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        obs.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.08 }
);

document
  .querySelectorAll(
    '.feature-card, .review-card, .cycle-card, .pfas-chemical, .gift-review-item, .ba-panel, .ls-img'
  )
  .forEach(function (el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(16px)';
    el.style.transition = 'opacity 0.55s ease, transform 0.55s ease';
    observer.observe(el);
  });

/* ── Anatomy block scroll reveal ─────────────────────────────────── */

var anatomyObserver = new IntersectionObserver(
  function (entries, obs) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        obs.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.1 }
);

document.querySelectorAll('[data-anatomy]').forEach(function (el) {
  anatomyObserver.observe(el);
});

/* ── Smooth scroll to #buy (from non-CTA links) ─────────────────── */

document.querySelectorAll('a[href="#buy"]').forEach(function (a) {
  a.addEventListener('click', function (e) {
    // Skip smooth-scroll when out-of-stock (redirect handler takes over)
    var avail = document.querySelector('.iron-skillet-section[data-product-available]');
    if (avail && avail.getAttribute('data-product-available') === 'false') return;
    e.preventDefault();
    document.getElementById('buy').scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
});

/* ── Out-of-stock redirect ───────────────────────────────────────── */
// When the product is marked out-of-stock (via a data attribute on the
// section root), CTA buttons redirect to /pages/out-of-stock instead of
// adding to cart.

/**
 * Builds the out-of-stock redirect URL with current user selections.
 *
 * @returns {string} Full path with query string, e.g.
 *   "/pages/out-of-stock?size=10&gifts=leather,seasoning&price=159"
 */
function buildOutOfStockUrl() {
  var params = [];

  // Selected size (inches), e.g. "8", "10", "12"
  if (currentSize) {
    params.push('size=' + encodeURIComponent(currentSize));
  }

  // Toggled gifts — comma-separated list of selected gift keys
  var selectedGifts = Object.keys(giftState).filter(function (key) {
    return giftState[key];
  });
  if (selectedGifts.length > 0) {
    params.push('gifts=' + encodeURIComponent(selectedGifts.join(',')));
  }

  // Current sale price (numeric, no dollar sign)
  if (currentPrice) {
    var priceNum = currentPrice.replace('$', '');
    params.push('price=' + encodeURIComponent(priceNum));
  }

  var qs = params.length > 0 ? '?' + params.join('&') : '';
  return '/pages/out-of-stock' + qs;
}

(function () {
  var section = document.querySelector('.iron-skillet-section[data-product-available]');
  if (!section) return;

  var isAvailable = section.getAttribute('data-product-available') !== 'false';

  // Remaining out-of-stock logic only applies when unavailable
  if (isAvailable) return;

  // Collect all CTA buttons and update them for out-of-stock state
  var allAtcBtns = document.querySelectorAll('[data-ps-atc-btn]');
  allAtcBtns.forEach(function (btn) {
    // Update visual state
    if (btn.classList.contains('btn-nav')) {
      btn.textContent = 'Sold Out';
    } else {
      btn.innerHTML = 'Sold Out — Join the Waitlist <span class="arrow">→</span>';
    }
    btn.style.opacity = '0.7';
    btn.style.pointerEvents = 'auto';

    // Override click to redirect with current selections as query params
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = buildOutOfStockUrl();
    });
  });
})();
